
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { ROUTES_ARCHIVOS } from '../constants/constant.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AnyARecord } from 'dns';

@Injectable({
    providedIn: 'root'
})
export class CuentaPorCobrarService {

    constructor(
        private httpClient: HttpClient,
        private apiService: ApiService
    ) { }

    public getEECC(codcli: string, solopendientes: boolean, incdocdes: boolean, ubicaciones: string) {
        return this.httpClient.get(environment.serviceUrl + "cliente/" + codcli + "/eecc?solopendientes=" + solopendientes + "&incdocdes=" + incdocdes + "&ubicaciones=" + ubicaciones, { observe: 'response' },)
    }

    public getEECP(codcli: string, solopendientes: boolean, incdocdes: boolean, ubicaciones: string) {
        return this.httpClient.get(environment.serviceUrl + "cliente/" + codcli + "/eecp?solopendientes=" + solopendientes + "&incdocdes=" + incdocdes + "&ubicaciones=" + ubicaciones, { observe: 'response' },)
    }

    public getDetalleEECC(codcli: string, solopendientes: boolean, incdocdes: boolean, ubicaciones: string, numint: any) {
        return this.httpClient.get(environment.serviceUrl + "cliente/" + codcli + "/eecc/detalle-cobrar?solopendientes=" + solopendientes + "&incdocdes=" + incdocdes + "&ubicaciones=" + ubicaciones + "&numint=" + numint, { observe: 'response' },)
    }

    public getDetalleEECP(codcli: string, solopendientes: boolean, incdocdes: boolean, ubicaciones: string, tipo: any, docu: any) {
        return this.httpClient.get(environment.serviceUrl + "cliente/" + codcli + "/eecc/detalle-pagar?solopendientes=" + solopendientes + 
        "&incdocdes=" + incdocdes + "&ubicaciones=" + ubicaciones + "&tipo=" + tipo + "&docu=" + docu, { observe: 'response' },)
    }

    public ubicaciones() {
        return this.httpClient.get(environment.serviceUrl + "tubicacion/buscar", { observe: 'response' },)
    }

    getEECC2(cia: string): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.compañia_obtener_url);
        return this.apiService.execGetQueryJson(`${cia}`)
    }

    getCtaCobCsltEstadoCuenta(data: any): Observable<any> {
        return this.httpClient.post(environment.serviceUrl + "ctaporcobrar/consultas/estadocuenta", data, { observe: 'response' });
    }

    listPendientes(codcli: any,tipdoc:any,fhasta:any,solodesc:any): Observable<any> {
        this.apiService.setUrlPathApi("cuentas-por-cobrar/"+codcli+"/documentos-pendientes");
        return this.apiService.execGetQueryJson(`?tipdoc=${tipdoc}&fhasta=${fhasta}&solodesc=${solodesc}`).pipe();
    }
    listPendientes2(tipdoc:any,docume: any,fhasta:any): Observable<any> {
        this.apiService.setUrlPathApi("cuentas-por-cobrar/documentos-pendientes");
        return this.apiService.execGetQueryJson(`?tipdoc=${tipdoc}&docume=${docume}&fhasta=${fhasta}`).pipe();
    }
    listPendientes_v2(tipdoc:any,docume: any,fhasta:any,solodesc:any): Observable<any> {
        this.apiService.setUrlPathApi("cuentas-por-cobrar/documentos-pendientes");
        return this.apiService.execGetQueryJson(`?tipdoc=${tipdoc}&docume=${docume}&fhasta=${fhasta}&solodesc=${solodesc}`).pipe();
    }
    obtenerDocumentos(tipdoc:any,docume:any){
        this.apiService.setUrlPathApi(`dcta-100/${tipdoc}/${docume}`);
        return this.apiService.execGetJson();
    }
    obtenerDocumentoExorta(tipdoc:any,docume:any,codpro:any){
       this.apiService.setUrlPathApi(`prov-100/buscar`);
       return this.apiService.execGetQueryJson(`?tipdoc=${tipdoc}&docume=${docume}&codpro=${codpro}`).pipe()
    }
    downloadPDFDocumentoPendientes1(codcli: any, codsuc: any, codven: any, tipDocs: any, codUbis: any, swincletdes: any, numint: any, factanti: any): Observable<any> {
        this.apiService.setUrlPathApi("ctaporcobrar/consultas/estadocuenta/documentospendiente/pdf");
        return this.apiService.executePostJson(`?codcli=${codcli}&codsuc=${codsuc}&codven=${codven}&tipDocs=${tipDocs}&codUbis=${codUbis}&swincletdes=${swincletdes}&numint=${numint}&factanti=${factanti}`).pipe();
    }

    downloadPDFDocumentoPendientes(params: any) {
        const httpOptions = {
            'responseType': 'arraybuffer' as 'json'
            //'responseType'  : 'blob' as 'json'        //This also worked
        };
        const fullUrl = environment.serviceUrl + `ctaporcobrar/consultas/estadocuenta/documentospendiente/pdf`;
        return this.httpClient.post(fullUrl, params, httpOptions);
    }
    downloadPDFDocumentoPendientesFecha(fhasta:any,codcli:any,tipdocs:any,codalms:any): Observable<any> {
        this.apiService.setUrlPathApi("reportes/cxc/documentos-pendientes-fecha/pdf");
        return this.apiService.execGetQueryJsonPDF(`?fhasta=${fhasta}&codcli=${codcli}&tipdocs=${tipdocs}&codalms=${codalms}`).pipe();
    }
    downloadPDFDocumentoCancelados(codcli: any, codven: any, codsuc: any,sucursalDesc:any,fdesde:any,fhasta:any, tipdocs: any,libros:any,orderby:any): Observable<any> {
        this.apiService.setUrlPathApi("reportes/cxc/cancelaciones/pdf");
        return this.apiService.execGetQueryJsonPDF(`?codcli=${codcli}&codven=${codven}&codsuc=${codsuc}&sucursalDesc=${sucursalDesc}&fdesde=${fdesde}&fhasta=${fhasta}&tipdocs=${tipdocs}&libros=${libros}&orderby=${orderby}`).pipe();
    }
    downloadExcelDocumentoCancelados(codcli: any, codven: any, codsuc: any,fdesde:any,fhasta:any, tipdocs: any,libros:any,orderby:any): Observable<any> {
        this.apiService.setUrlPathApi("reportes/cxc/cancelaciones/excel");
        return this.apiService.execGetQueryJsonPDF(`?codcli=${codcli}&codven=${codven}&codsuc=${codsuc}&fdesde=${fdesde}&fhasta=${fhasta}&tipdocs=${tipdocs}&libros=${libros}&orderby=${orderby}`).pipe();
    }
    downloadExcel(params: any): Observable<any> {
        this.apiService.setUrlPathApi('ctaporcobrar/consultas/estadocuenta/documentospendiente/excel.xlsx?'+params);
        return this.apiService.execGetQueryJsonPDF('').pipe();
    }

    downloadExcel2(params: any): Observable<any> {

        // const fullUrl = environment.serviceUrl + `ctaporcobrar/consultas/estadocuenta/documentospendiente/excel.xlsx`;
        // return this.httpClient.get(fullUrl, params);
        const httpOptions = {
            'responseType': 'arraybuffer' as 'json'
            //'responseType'  : 'blob' as 'json'        //This also worked
        };
        const fullUrl = environment.serviceUrl + `ctaporcobrar/consultas/estadocuenta/documentospendiente/excel.xlsx`;
        return this.httpClient.post(fullUrl, params, httpOptions);
    }
    reportesDocumentosPendientesExcel(fhasta:any,codcli:any,tipdocs:any,codalms:any):Observable<any>{
        this.apiService.setUrlPathApi('reportes/cxc/documentos-pendientes-fecha/excel');
        return this.apiService.execGetQueryJsonPDF(`?fhasta=${fhasta}&codcli=${codcli}&tipdocs=${tipdocs}&codalms=${codalms}`).pipe()
    }
    /* public insertContacto(contacto: any) {
         this.apiService.setUrlPathApi("contacto");
         return this.apiService.executePostJson(contacto).pipe();
     }
     public actualizar_contacto(contacto: any) {
         this.apiService.setUrlPathApi("contacto");
         return this.apiService.executePutJson(contacto).pipe();
     }
     */

     getdownloadPDFEstadoDeCuenta(params: any) {

        const httpOptions = {
            'responseType': 'arraybuffer' as 'json'
            //'responseType'  : 'blob' as 'json'        //This also worked
        };

        const fullUrl = environment.serviceUrl + `ctaporpagar/estadocuenta/estadocuenta/impresionestadocuenta/pdf`;
        return this.httpClient.post(fullUrl, params, httpOptions);
    }


    consultaDocPendientes(codcli: any,tipdoc: number, docume: string, chksaldo: boolean) {
        return this.httpClient.get(environment.serviceUrl + "ctaporcobrar/consultas/documentos-pendientes?tipdoc=" + tipdoc + "&docume=" + encodeURIComponent(docume) + "&codcli=" + encodeURIComponent(codcli) +"&chksaldo=" + chksaldo, { observe: 'response' },)
    }

    consultaDocumentosPendientes(numint:number){
        this.apiService.setUrlPathApi(`ctaporcobrar/consultas/documentos-pendientes/${numint}`);
        return this.apiService.execGetJson();
    }
}